import apiClient from './client';

export interface MessageUserRef {
  id: number;
  firstName: string;
  lastName: string;
  email?: string;
}

export interface ConversationListItem {
  id: number;
  name: string | null;
  isGlobal: boolean;
  lastMessageAt: string | null;
  members: MessageUserRef[];
  lastMessage: {
    id: number;
    conversationId: number;
    senderId: number;
    content: string;
    createdAt: string;
    sender: MessageUserRef;
  } | null;
  unreadCount: number;
  userLastReadAt: string | null;
  createdAt: string;
}

export interface ConversationMessage {
  id: number;
  conversationId: number;
  senderId: number;
  content: string;
  createdAt: string;
  sender: MessageUserRef;
}

export interface ConversationDetailResponse {
  success: boolean;
  data: {
    conversation: {
      id: number;
      name: string | null;
      isGlobal: boolean;
      members: MessageUserRef[];
      createdAt: string;
    };
    messages: ConversationMessage[];
    hasMore: boolean;
  };
}

export const listConversations = async (): Promise<{ success: boolean; data: ConversationListItem[] }> => {
  const response = await apiClient.get('/messages/conversations');
  return response.data;
};

export const getConversation = async (id: number): Promise<ConversationDetailResponse> => {
  const response = await apiClient.get<ConversationDetailResponse>(`/messages/conversations/${id}`);
  return response.data;
};
